module.exports = __webpack_public_path__ + "static/media/bg8.23f9265c.jpg";